import * as Actions from '../actions';

const initialState = {
	registerSuccess: false,
	loginSuccess: false,
	error: null,
	// Pending two-step sign-in: { challengeToken, email, enforcedBy, loading, error }
	twoFactor: null
};

// Start a fresh sign-in flow (no success flags, no error, no pending 2FA) while
// keeping the provider lists the login page fetched. Those are page data, not
// flow state: dropping them on every error re-rendered the login tab and
// blanked the form under the user.
const resetFlow = (state, patch) => ({
	...initialState,
	activeLdapServers: state.activeLdapServers,
	activeOidcProviders: state.activeOidcProviders,
	...patch
});

const login = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_LOGIN_SUCCESS: {
			return resetFlow(state, { loginSuccess: true });
		}
		case Actions.SET_REGISTER_SUCCESS: {
			return resetFlow(state, { registerSuccess: !state.registerSuccess });
		}
		case Actions.SET_ERROR: {
			return resetFlow(state, { error: action.payload });
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.SET_TWO_FACTOR_CHALLENGE: {
			return resetFlow(state, { twoFactor: { ...action.payload, loading: false, error: null } });
		}
		case Actions.SET_TWO_FACTOR_STATUS: {
			if (!state.twoFactor) return state;
			return {
				...state,
				twoFactor: { ...state.twoFactor, ...action.payload }
			};
		}
		case Actions.CLEAR_TWO_FACTOR_CHALLENGE: {
			return {
				...state,
				twoFactor: null
			};
		}
		case Actions.CLEAR_AUTH: {
			return initialState;
		}
		case Actions.SET_ACTIVE_LDAP_SERVERS: {
			return {
				...state,
				activeLdapServers: action.payload
			};
		}
		case Actions.SET_ACTIVE_OIDC_PROVIDERS:
			return {
				...state,
				activeOidcProviders: action.payload
		};
		default: {
			return state;
		}
	}
};

export default login;
